import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

import { isCatalogHubPath } from './is-catalog-hub-path';

export const useIsCatalogHub = () => {
  const { asPath } = useRouter();
  const {
    i18n: { language },
  } = useTranslation();
  return isCatalogHubPath(asPath, language);
};
